module.exports = __webpack_public_path__ + "static/media/logo.14c1248e.jpeg";